var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("page-header", {
        attrs: {
          light: "",
          "dark-crumb": "",
          title: "Политика использования Cookie",
        },
      }),
      _c("content-wrapper-block", [
        _c("div", { staticClass: "cookie-policy" }, [
          _c("div", { staticClass: "cookie-policy-text" }, [
            _c("p", [
              _vm._v(
                " АО «ГК ОСНОВА» (далее — Оператор) обрабатывает данные, указанные в настоящем документе (далее — Политика), собранные в процессе использования Пользователями текущего Сайта. При нажатии кнопки «Принять» в окне-уведомлении об обработке Cookie, Вы даете свое согласие на обработку Ваших Cookie. Вы также можете отказаться от обработки Cookie в соответствии с пунктом 5 настоящей Политики. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("1. Что такое файлы Cookie?")]),
              _c("br"),
              _c("b", [_vm._v("Файлы cookie")]),
              _vm._v(
                " — это небольшой фрагмент данных, который Сайт запрашивает у браузера, используемого на Вашем компьютере или мобильном устройстве. Файлы cookie содержат информацию о Ваших действиях на Сайте, а также могут содержать сведения об оборудовании, дату и время сессии."
              ),
              _c("br"),
              _c("b", [_vm._v("Сайт")]),
              _vm._v(
                " — это совокупность текстов, графических элементов, дизайна, изображений, программного кода, и иных результатов интеллектуальной деятельности, содержащихся в информационно-телекоммуникационной сети «Интернет» под доменным именем «zk-mainstreet.ru», а также его поддоменов."
              ),
              _c("br"),
              _c("b", [_vm._v("Пользователь")]),
              _vm._v(
                " – физическое лицо, намеревающееся принять Политику использования Cookies или принявшее его, а также использующее Сайт посредством информационно-телекоммуникационной сети Интернет. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("2. Как мы используем Ваши Cookie?")]),
              _c("br"),
              _vm._v(
                " Файлы cookie используются Оператором в целях улучшения и обеспечения нормальной работоспособности Сайта, а также в целях совершенствования продуктов и услуг, предоставляемых Оператором. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("3. Какие виды Cookie мы используем?")]),
              _c("br"),
              _c("b", [_vm._v("Сессионные.")]),
              _vm._v(
                " Существуют только во временной памяти в течение времени, когда пользователь находится на странице Сайта. Браузеры обычно удаляют сессионные файлы cookie после того, как пользователь закрывает окно Сайта. Сессионные файлы cookis позволяют Сайту помнить информацию о выборе пользователя на предыдущей странице Сайта, чтобы избежать необходимости повторного ввода информации."
              ),
              _c("br"),
              _c("b", [_vm._v("Постоянные.")]),
              _vm._v(
                " Файлы cookie, которые хранятся на Вашем устройстве и не удаляются при закрытии браузера. Постоянные файлы cookie могут сохранять пользовательские настройки для Сайта, позволяя использовать эти предпочтения в будущих сеансах использования Сайта. Такие файлы cookie позволяют идентифицировать Вас как уникального пользователя Сайта, и при возвращении на Сайт помогают вспомнить информацию о Вас и ранее совершенных Вами действиях."
              ),
              _c("br"),
              _c("b", [_vm._v("Обязательные.")]),
              _vm._v(
                " Минимальный набор файлов cookie, использование которых необходимо для обеспечения правильной и бесперебойной работы Сайта."
              ),
              _c("br"),
              _c("b", [_vm._v("Аналитические / маркетинговые.")]),
              _vm._v(
                " Эти файлы cookie помогают понять, как Вы взаимодействуете с Сайтом, предоставляя информацию о тех страницах, которые Вы посетили и количестве времени, которое Вы провели на Сайте. Так же эти файлы используются для улучшения функционала Сайта. Файлы cookie, относящиеся к аналитике, помогают измерять эффективность рекламных кампаний и оптимизировать содержание Сайтов для тех, кого заинтересовала реклама владельца Сайта или его партнеров. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("4. Как мы обрабатываем Ваши Cookie?")]),
              _c("br"),
              _vm._v(
                " На Сайте происходит сбор и обработка обезличенных данных с использованием метрических программ и систем аналитики, таких как «Яндекс.Метрика». Эта услуга предоставляется компанией ООО «ЯНДЕКС» (ИНН 7736207543). Дополнительную информацию о сервисе «Яндекс.Метрика» и политике конфиденциальности ООО «ЯНДЕКС» можно найти по адресу: "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://yandex.ru/legal/confidential/",
                    target: "_blank",
                  },
                },
                [_vm._v("https://yandex.ru/legal/confidential/")]
              ),
              _vm._v(" и "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://yandex.ru/legal/metrica_termsofuse/",
                    target: "_blank",
                  },
                },
                [_vm._v("https://yandex.ru/legal/metrica_termsofuse/")]
              ),
              _vm._v(". "),
            ]),
            _c("p", [
              _c("b", [_vm._v("5. Управление файлами Cookie")]),
              _c("br"),
              _vm._v(
                " Вы в любой момент можете принять решение об отказе предоставления и использования файлов cookie или удалить уже сохраненные cookie в настройках Вашего браузера. При этом Вы можете просматривать текст на Сайте, однако возможности индивидуальной настройки отображения, некоторые функции, сервисы, инструменты и возможности Сайта могут быть недоступны."
              ),
              _c("br"),
              _vm._v(
                " Если Вы решили отказаться от обработки файлов cookie, то Сайт будет использовать только обязательные cookie, необходимые для функционирования Сайта. "
              ),
            ]),
            _c(
              "p",
              [
                _c("b", [_vm._v("6. Как с нами связаться?")]),
                _c("br"),
                _vm._v(
                  " Настоящая Политика размещена на Сайте по адресу: https://zk-mainstreet.ru/cookie-policy и действует бессрочно до ее замены новой Политикой. В случае возникновения вопросов, связанных с обработкой Ваших персональных данных или реализации Ваших прав как субъекта персональных данных, пожалуйста, свяжитесь с нами, используя один из способов, указанных на странице "
                ),
                _c(
                  "router-link",
                  {
                    attrs: { slot: "link", to: { name: "ContactPage" } },
                    slot: "link",
                  },
                  [_vm._v("«Контакты»")]
                ),
                _vm._v(". "),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }